import timer_gen_2 from '@devices/settings/device_settings/timer_gen_2.js';
import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import night_mode_gen_2 from '@devices/settings/device_settings/night_mode_gen_2.js';
import scripts_gen_2 from '@devices/settings/device_settings/scripts_gen_2.js';
import networks_gen_2_pro from '@devices/settings/device_settings/networks_gen_2_pro.js';
import virtual_components_pro_devices from '@devices/settings/device_settings/virtual_components_pro_devices.js';
import safety_gen_2 from '@devices/settings/device_settings/safety_gen_2.js';
import app_setting_plus_rgbw_gen_2 from '@devices/settings/common_settings/app_setting_plus_rgbw_gen_2.js';
import share from '@devices/settings/device_settings/share.js';
import rgbww_pro_settings_gen_2 from '@devices/settings/device_settings/rgbww_pro_settings_gen_2.js';
import rgbww_pro_settings_gen_2_light from '@devices/settings/common_settings/rgbww_pro_settings_gen_2_light';
import bluetooth_bt_home_control_gen_2 from '@devices/settings/device_settings/bluetooth_bt_home_control_gen_2';
import addon_sensors, { addon_pro_lora_devices } from '@devices/settings/device_settings/addon_sensors';

export default {
	name: 'ShellyProRGBWWPM',
	friendly_name: 'Pro RGBWW PM',
	family: 'light',
	isPM: true,
	addons: addon_pro_lora_devices,
	reset_from_input: true,
	modes: {
		light: {
			channels: 5,
			notifications: [
				'offline',
				'device_problem',
				'forgotten_lights',
				'overvoltage',
				'overtemperature',
			],
			color_temp: false,
			slider: 'brightness',
			brightness: 0,
			effects: false,
			settings: [
				timer_gen_2,
				schedule_gen_2,
				webhooks_gen_2,
				night_mode_gen_2,
				addon_sensors,
				scripts_gen_2,
				networks_gen_2_pro,
				bluetooth_bt_home_control_gen_2,
				virtual_components_pro_devices,
				safety_gen_2,
				app_setting_plus_rgbw_gen_2,
				share,
				rgbww_pro_settings_gen_2,
			],
		},
		rgbcct: {
			channels: 2,
			notifications: [
				'offline',
				'device_problem',
				'forgotten_lights',
				'overvoltage',
				'overtemperature',
			],
			color_temp: { minValue: 2700, maxValue: 6500 },
			color: true,
			slider: 'brightness',
			has_white: false,
			brightness: 0,
			settings: rgbww_pro_settings_gen_2_light,
		},
		cctx2: {
			channels: 2,
			notifications: [
				'offline',
				'device_problem',
				'forgotten_lights',
				'overvoltage',
				'overtemperature',
			],
			color_temp: { minValue: 2700, maxValue: 6500 },
			color: false,
			slider: 'brightness',
			brightness: 0,
			has_white: false,
			settings: rgbww_pro_settings_gen_2_light,
		},
		rgbx2light: {
			channels: 3,
			notifications: [
				'offline',
				'device_problem',
				'forgotten_lights',
				'overvoltage',
				'overtemperature',
			],
			color_temp: false,
			color: true,
			slider: 'brightness',
			brightness: 0,
			has_white: false,
			settings: rgbww_pro_settings_gen_2_light,
		},
	},
};
